<div class="confirm-modal ig-modal set-contacts-modal">


    <div [formGroup]="hubContactsForm">
        <mat-tab-group>
            <mat-tab>
                <ng-template mat-tab-label>
                    Client URLs
                </ng-template>
                <div class="m-t-3">
                    <ig-row>
                        <ig-col [xs]="12" [md]="12">
                            <ig-field label="Client site event calendar URL" [required]="false"
                                [formControl]="hubContactsForm.get('event')" icon="date_range"
                                [(ngModel)]="contact.eventCalendarURL">
                            </ig-field>
                        </ig-col>
                    </ig-row>
                    <ig-row>
                        <ig-col [xs]="12" [md]="12">
                            <ig-field label="Client site itinerary URL" [required]="false"
                                [formControl]="hubContactsForm.get('tour')" icon="room"
                                [(ngModel)]="contact.moreToursURL">
                            </ig-field>
                        </ig-col>
                    </ig-row>
                    <!-- <ig-row>
                        <ig-col [xs]="12" [md]="12">
                            <ig-field label="Client site place calendar URL" [required]="false"
                                [formControl]="hubContactsForm.get('place')" icon="room"
                                [(ngModel)]="contact.placeCalendarURL">
                            </ig-field>
                        </ig-col>
                    </ig-row> -->
                    <ig-row>
                        <ig-col [xs]="12" [md]="12">
                            <ig-accordion id="place-type" icon="room" title="Places URL Mapping (expand to set)"
                                class="m-t-2">
                                <div style="max-height:400px;overflow:auto" formArrayName="dynamicFields">

                                    <form [formGroup]="placeForm" class="url-form">
                                        <div formArrayName="dynamicFields">
                                            <div *ngFor="let field of getControls(); let i = index" [formGroupName]="i"
                                                style="margin-bottom: 32px;">
                                                <div style="text-align: left;margin-bottom: 6px;color:gray">Group
                                                    {{i+1}}</div>
                                                <input formControlName="igURL" type="text"
                                                    placeholder="ImGoing place category URL">
                                                <input formControlName="clientURL" type="text"
                                                    placeholder="Client website place category URL">
                                            </div>
                                        </div>
                                    </form>
                                    <div item style="color:#41abf3;cursor:pointer" (click)="addPlaceURL()">+ Add</div>
                                </div>
                            </ig-accordion>
                        </ig-col>
                    </ig-row>

                </div>
            </mat-tab>
            <mat-tab>
                <ng-template mat-tab-label>
                    Contacts
                </ng-template>

                <div>
                    <ig-row>
                        <ig-col [xs]="12" [md]="6">
                            <ig-field label="Name" [required]="true" [formControl]="hubContactsForm.get('name')"
                                icon="people" [(ngModel)]="contact.name">
                            </ig-field>
                        </ig-col>
                        <ig-col [xs]="12" [md]="6">
                            <ig-field label="Phone Number" [formControl]="hubContactsForm.get('number')"
                                icon="local_phone" type="number" [(ngModel)]="contact.number">
                            </ig-field>
                        </ig-col>
                    </ig-row>
                    <ig-row>
                        <ig-col [xs]="12">
                            <ig-field label="Email" [formControl]="hubContactsForm.get('email')" icon="mail_outline"
                                [(ngModel)]="contact.email">
                            </ig-field>
                        </ig-col>
                    </ig-row>

                    <br />
                    <p>Client trip inquiry contact email</p>
                    <ig-row>
                        <ig-col [xs]="12">
                            <ig-field label="Email" [formControl]="hubContactsForm.get('inquiryEmail')"
                                icon="mail_outline" [(ngModel)]="contact.inquiryEmail">
                            </ig-field>
                        </ig-col>
                    </ig-row>

                </div>
            </mat-tab>
        </mat-tab-group>

        <ig-success-wrap #success>
            <ig-button size="md" [isAsync]="true" class="ig-blue-btn m-t-4" (trigger)="save($event)">save</ig-button>
        </ig-success-wrap>
    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/admin/accounts/set.contacts/set.contacts.modal.component.html